import * as yup from "yup";
import { validationArraySelect, validationConfirmNewPasswordL, validationEmailField, validationNewPassword, validationNotEmpty } from "./defaultValidations";

export default yup.object({
  firstName: validationNotEmpty("First Name"),
  lastName: validationNotEmpty("Last Name"),
  email: validationEmailField("Email"),
  phoneNumber: validationNotEmpty("Phone Number"),
  status: validationNotEmpty("Status"),
});
